export const getSaveMessage = (value) => {
  return {
    type: "GET_SAVE_MESSAGE",
    payload: value,
  };
};
